import { BLOCK_REGISTRY } from "../blockRegistry";

const CONTACT_US_DEFAULT_BLOCKS = [
  { id: "default-contact-hero", type: "contact-hero" },
  { id: "default-contact-details", type: "contact-details" },
].map((block) => ({
  ...block,
  fields: BLOCK_REGISTRY[block.type].defaultFields,
}));

export default CONTACT_US_DEFAULT_BLOCKS;
